/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";
import { DropdownButton, NavItem } from "react-bootstrap";
import {
  IoFolder,
  IoTrash,
  IoEllipsisVertical,
  IoLockClosed
} from "react-icons/io5";

import { orderBy, groupBy, uniq, map } from "lodash";

import Loading from "../common/Loading";

const CodeList = ({ codes, onClickEdit, onClickDelete }) => {
  let codesView = (
    <div className="vertical-center -full">
      <Loading active={!codes.length} />
    </div>
  );

  const group = groupBy(codes, "entity");

  const columns = [
    {
      Header: "Field",
      accessor: "field",
      PivotValue: ({ value }) => (
        <span style={{ textTransform: "capitalize" }}>
          {value.replace(/[_-]/g, " ")}
        </span>
      )
    },
    {
      Header: "Value",
      accessor: "value"
    },
    {
      Header: "Label",
      accessor: "label"
    },
    {
      Header: "Order",
      accessor: "order",
      Aggregated: () => <span />
    },
    {
      Header: "",
      accessor: "_id",
      maxWidth: 80,
      Aggregated: () => <span />,
      Cell: ({ original, value }) => {
        if (original && original.read_only) {
          return <IoLockClosed />;
        }
        return (
          <div className="text-center actions">
            <DropdownButton
              id="codes-list-dropdown"
              title={<IoEllipsisVertical />}
            >
              <NavItem onClick={() => onClickEdit(value)}>
                <IoFolder />
                View
              </NavItem>
              <NavItem onClick={() => onClickDelete(value)}>
                <IoTrash />
                Delete
              </NavItem>
            </DropdownButton>
          </div>
        );
      }
    }
  ];

  if (codes.length > 0) {
    codesView = Object.keys(group)
      .sort()
      .map((entity, i) => (
        <div key={i}>
          <h3>{entity}</h3>
          <ReactTable
            className="-highlight pd-20"
            data={orderBy(group[entity], "label")}
            showPagination={false}
            columns={columns}
            pageSize={uniq(map(group[entity], "field")).length}
            pivotBy={["field"]}
          />
        </div>
      ));
  }

  return <div>{codesView}</div>;
};

CodeList.propTypes = {
  codes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      entity: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onClickEdit: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired
};

export default CodeList;
